import React from 'react';

const isStyleObject = (obj) => typeof obj === 'object';

export default class SingleOtpInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.input = React.createRef();
  }

  // Focus on first render
  // Only when shouldAutoFocus is true
  componentDidMount() {
    const { focus, shouldAutoFocus } = this.props;
    const { current: inputEl } = this.input;

    if (inputEl && focus && shouldAutoFocus) {
      inputEl.focus();
    }
  }

  componentDidUpdate(prevProps) {
    const { focus } = this.props;
    const { current: inputEl } = this.input;

    // Check if focusedInput changed
    // Prevent calling function if input already in focus
    if (prevProps.focus !== focus && inputEl && focus) {
      inputEl.focus();
      inputEl.select();
    }
  }

  getClasses = (...classes) => classes.filter((c) => !isStyleObject(c) && c !== false).join(' ');

  render() {
    const {
      placeholder,
      inputStyle,
      focus,
      isDisabled,
      correctStyle,
      hasErrored,
      errorStyle,
      focusStyle,
      disabledStyle,
      shouldAutoFocus,
      value,
      className,
      ...rest
    } = this.props;

    return (
      <div
        className={`${className} ${(value !== undefined && correctStyle) ? correctStyle : ''} ${hasErrored && errorStyle ? errorStyle : ''}`}
        disabled={isDisabled}
      >
        <input
          autoComplete="off"
          placeholder={placeholder}
          className={this.getClasses(
            inputStyle,
            focus && focusStyle,
            isDisabled && disabledStyle,
            hasErrored && errorStyle,
          )}
          type="number"
          maxLength="1"
          ref={this.input}
          disabled={isDisabled}
          value={value || ''}
          {...rest}
        />
      </div>
    );
  }
}
